import { RegisteredComponent } from "@builder.io/sdk-react";

export const navatticBlockConfig: Omit<RegisteredComponent, "component"> = {
  name: "Navattic",
  noWrap: true,
  shouldReceiveBuilderProps: {
    builderContext: true,
  },
  canHaveChildren: false,
  inputs: [
    {
      name: "campaignId",
      type: "string",
      friendlyName: "Campaign ID",
      localized: false,
      required: true,
    },
    {
      name: "code",
      type: "longText",
      localized: false,
      required: true,
      helperText:
        "Paste the raw Navattic embed snippet. It is injected as HTML and any embedded scripts are executed after mount.",
    },
  ],
};
